import { render, staticRenderFns } from "./transnote.vue?vue&type=template&id=ae6f88a8&"
import script from "./transnote.vue?vue&type=script&lang=js&"
export * from "./transnote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports